import { render } from "./MenuWrapper.vue?vue&type=template&id=42dbc5ee"
import script from "./MenuWrapper.vue?vue&type=script&lang=js"
export * from "./MenuWrapper.vue?vue&type=script&lang=js"

import "./MenuWrapper.vue?vue&type=style&index=0&id=42dbc5ee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__